import { z } from "zod";

// Re-exported so this module stays the settings form's single import, but the list is
// the shared one. It used to hold the pre-February-2026 display labels, which meant the
// catalogue was still creating the encoding the patient form had stopped producing —
// the source-side half of KIN-1680.
export { ADMINISTRATION_METHOD_OPTIONS } from "features/immunizations/constants/administrationMethods";

export const vaccineModalSchema = z
  .object({
    name: z.string().min(1, { message: "Vaccine name is required." }),
    type: z.string().min(1, { message: "Vaccine type is required." }),
    manufacturer: z.string().min(1, { message: "Manufacturer is required." }),
    administrationMethod: z
      .string()
      .min(1, { message: "Administration method is required." }),
    route: z.string().min(1, { message: "Route is required." }),
    doseMl: z
      .string()
      .optional()
      .refine((value) => !value || !Number.isNaN(Number(value)), {
        message: "Dose must be a valid number.",
      }),
    startAge: z
      .string()
      .optional()
      .refine((value) => !value || !Number.isNaN(Number(value)), {
        message: "Start age must be a valid number.",
      }),
    endAge: z
      .string()
      .optional()
      .refine((value) => !value || !Number.isNaN(Number(value)), {
        message: "End age must be a valid number.",
      }),
    webUrl: z.string().optional(),
    documentLink: z.string().optional(),
    vaccineCodeId: z.string().optional(),
    vaccineCodeName: z.string().optional(),
    vaccineCodeCvxCode: z.string().optional(),
    vaccineCodeMvxCode: z.string().optional(),
  })
  .superRefine((data, context) => {
    const startAgeNumber = Number(data.startAge);
    const endAgeNumber = Number(data.endAge);

    if (data.startAge && data.endAge && startAgeNumber >= endAgeNumber) {
      context.addIssue({
        path: ["endAge"],
        code: z.ZodIssueCode.custom,
        message: "End age must be greater than start age.",
      });
    }
  });

export const VACCINE_MODAL_DEFAULT_VALUES = {
  name: "",
  type: "",
  manufacturer: "",
  administrationMethod: "",
  route: "",
  doseMl: "",
  startAge: "",
  endAge: "",
  webUrl: "",
  documentLink: "",
  vaccineCodeId: "",
  vaccineCodeName: "",
  vaccineCodeCvxCode: "",
  vaccineCodeMvxCode: "",
};
